<div class="indicator">
  <div
    class="fill"
    [ngClass]="passwordState.level"
    [@barChange]="{ value: slidingDoorValue, params: { outWidth: outWidth, inWidth: inWidth } }"
  ></div>
</div>
<div class="mat-caption" data-cy="password-state-message" [@textChange]="slidingDoorValue">
  {{ passwordState.message }}
</div>
